import type { Provider } from '@angular/core';
import { NATIVE_BRIDGE, type NativeBridge } from './native-bridge';
import { AndroidNativeBridge } from './android-bridge';
import { MockNativeBridge } from './native-bridge.mock';

/**
 * Choose a bridge implementation at startup.
 *
 * The real one when an Android host is present, the mock otherwise — so the app
 * runs in a plain browser with no hardware, which is what makes the session and
 * toggle behaviour developable and testable without a phone and a stethoscope.
 */
export function provideNativeBridge(): Provider {
  return {
    provide: NATIVE_BRIDGE,
    useFactory: (): NativeBridge => {
      const hasHost = typeof window.TelemedBridge !== 'undefined';

      return hasHost ? new AndroidNativeBridge() : new MockNativeBridge();
    },
  };
}
